import React, { useState } from 'react'

import { ConfirmationModal, Toast } from 'components'

// Utils and Services
import { updateLeadContactStatus } from 'services/lead-contact'
import { FETCHING_STATUS } from 'utils/constants'
import { useTranslation } from 'react-i18next'

type Props = {
  contactId: string
  isActive: boolean
  onAction: (success?: boolean) => void
}

const DeactivateContactDetail: React.FC<Props> = ({ contactId, isActive, onAction }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const { t } = useTranslation()

  const handleDeleteContact = async () => {
    setIsSubmitting(true)

    const response = await updateLeadContactStatus({ contact_id: contactId, is_active: !isActive })

    setIsSubmitting(false)

    if (response.status === FETCHING_STATUS.fail) {
      // Toast.toastMessage({ actionKey: 'deactivate', subject: 'lead_contact', variant: 'error' })
      Toast.toastMessage({ variant: 'error', message: response.error?.message })

      return
    }

    Toast.toastMessage({ actionKey: 'deactivate', subject: 'lead_contact', variant: 'success' })
    onAction(true)
  }

  return (
    <ConfirmationModal
      isSubmitting={isSubmitting}
      cancel={() => onAction(false)}
      submit={handleDeleteContact}
      variant="deactivate"
      name={t('contact_lbl').toLowerCase()}
    />
  )
}

export default DeactivateContactDetail
